import { $t } from "@klondpay/locales";
const Layout = () => import("/@/layout/index.vue");

const channelRouter = {
  path: "/channel",
  component: Layout,
  redirect: "/channel/admin",
  meta: {
    icon: "channel-admin",
    title: $t("menus.channel"),
    rank: 1,
    authority: ["acquirer.acquirer.channel"]
  },
  children: [
    {
      path: "/channel/admin",
      name: "ChannelTitle",
      component: () => import("/@/views/channel-admin/ChannelAdmin/index.vue"),
      meta: {
        title: $t("channel.channelTitle"),
        keepAlive: true,
        showParent: true,
        authority: ["acquirer.acquirer.channel"]
      }
    },
    {
      path: "/channel/admin/detail",
      name: "ChannelDetail",
      component: () => import("/@/views/channel-admin/ChannelDetail/index.vue"),
      meta: {
        title: $t("channel.channelDetail"),
        showLink: false,
        authority: ["acquirer.acquirer.channel.update"],
        activeMenu: "/channel/admin"
      }
    },
    {
      path: "/channel/add",
      name: "ChannelAdd",
      component: () => import("/@/views/channel-admin/ChannelAdd/index.vue"),
      meta: {
        title: $t("channel.channelAdd"),
        showLink: false,
        authority: ["acquirer.acquirer.channel.update"],
        activeMenu: "/channel/admin"
      }
    }
  ]
};

export default channelRouter;
